// 登录注册相关
function getUrlParmas(url) {
  let vars = {};
  url.replace(/[?&]+([^=&]+)=([^&#]*)/gi, function(m, key, value) {
  vars[key] = value;
  });
  return vars;
}
let unityLoginTitle = getUrlParmas(decodeURIComponent(window.location.href)).name + '账号安全中心'
console.log(unityLoginTitle,'unityLoginTitle')
const PS_ROUTES = [
  // pc端路由
  {
    path: "/404",
    name: "pc-404",
    component: resolve => {
      require(["../pages/pc/404.vue"], resolve);
    },
    meta: {
      title: "404-好未来帐号安全中心"
    }
  },
  {
    path: "/",
    name: "",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "index",
    component: resolve => {
      require(["../pages/pc/index.vue"], resolve);
    },
    meta: {
      title: "好未来帐号安全中心"
    }
  },
  {
    path: "/helpCenter",
    name: "helpCenter",
    component: resolve => {
      require(["../pages/pc/helpCenter.vue"], resolve);
    },
    meta: {
      title: "帮助中心-好未来帐号安全中心"
    }
  },
  {
    path: "/login",
    name: "login",
    component: resolve => {
      require(["../pages/pc/login.vue"], resolve);
    },
    meta: {
      title: "登录-好未来帐号安全中心"
    }
  },
  {
    path: "/touch/login",
    name: "touchLogin",
    component: resolve => {
      require(["../pages/touch/passport/login.vue"], resolve);
    },
    meta: {
      title: "登录-好未来帐号安全中心"
    }
  },
  {
    path: "/touch/wxRiskCheck",
    name: "wxRiskCheck",
    component: resolve => {
      require(["../pages/touch/passport/wxRiskCheck.vue"], resolve);
    },
    meta: {
      title: "登录-好未来帐号安全中心"
    }
  },
  {
    path: "/accountSet",
    name: "accountSet",
    component: resolve => {
      require(["../pages/pc/accountSetIndex.vue"], resolve);
    },
    children: [
      {
        /**
         * type: 'forget' => 找回密码, 'change' => 修改密码
         */
        path: "/passwordSetFirst",
        name: "passwordSetFirst",
        component: resolve => {
          require(["../pages/pc/passwordSetFirst.vue"], resolve);
        },
        meta: {
          title: "修改密码-好未来帐号安全中心"
        }
      },
      {
        /*
         * type：'set' => 设置密码， 'forget' => 忘记密码  'change': 修改密码
         * tag: '' => 校验手机返回的标识
         */
        path: "/passwordSetNext",
        name: "passwordSetNext",
        component: resolve => {
          require(["../pages/pc/passwordSetNext.vue"], resolve);
        },
        meta: {
          title: "修改密码-好未来帐号安全中心"
        }
      },
      {
        path: "/phoneSet",
        name: "phoneSet",
        component: resolve => {
          require(["../pages/pc/phoneSet.vue"], resolve);
        },
        meta: {
          title: "换绑手机-好未来帐号安全中心"
        }
      },
      {
        /**
         * type: 'change' => 修改手机号，'bind' => 绑定手机号
         * tag: '' => 校验手机号返回的标识
         */
        path: "/phoneSetNext",
        name: "phoneSetNext",
        component: resolve => {
          require(["../pages/pc/phoneSetNext.vue"], resolve);
        },
        meta: {
          title: "换绑手机-好未来帐号安全中心"
        }
      },
      {
        /**
         * type: 'bindPhone' =>'绑定手机号',
         *       'changePhone' => '修改手机号',
         *       'setPassword' => '设置密码',
         *       'changePassword' => '修改密码',
         *       'forgetPassword' => '忘记密码’
         * phone: '' => 新的登录手机号
         */
        path: "/accountSetSuccess",
        name: "accountSetSuccess",
        component: resolve => {
          require(["../pages/pc/accountSetSuccess.vue"], resolve);
        },
        meta: {
          title: "操作成功-好未来帐号安全中心"
        }
      }
    ]
  },
  {
    path: "/touch",
    name: "touch",
    redirect: "touch/index"
  },
  {
    path: "/touch/index",
    name: "touchIndex",
    component: resolve => {
      require(["../pages/touch/passport/index.vue"], resolve);
    },
    meta: {
      title: "好未来帐号安全中心"
    }
  },
  {
    path: "/touch/authorization", // 账号绑定授权登录touch页面
    name: "touchauthorization",
    component: resolve => {
      require(["../pages/touch/passport/authorization.vue"], resolve);
    },
    meta: {
      title: "帐号授权"
    }
  },
  {
    path: "/authorization", // 账号绑定授权登录pc页面
    name: "touchauthorization",
    component: resolve => {
      require(["../pages/touch/passport/authorization.vue"], resolve);
    },
    meta: {
      title: "帐号授权"
    }
  },
  {
    path: "/touch/authorizationFail", // 账号绑定授权登录touch页面
    name: "touchauthorizationFail",
    component: resolve => {
      require(["../pages/touch/passport/authorizationFail.vue"], resolve);
    },
    meta: {
      title: "帐号授权"
    }
  },
  {
    path: "/authorizationFail", // 账号绑定授权登录pc页面
    name: "authorizationFail",
    component: resolve => {
      require(["../pages/touch/passport/authorizationFail.vue"], resolve);
    },
    meta: {
      title: "帐号授权"
    }
  },
  {
    path: "/authorizationProtocol", // 账号绑定授权登录pc页面
    name: "authorizationProtocol",
    component: resolve => {
      require(["../pages/touch/passport/authorizationProtocol.vue"], resolve);
    },
    meta: {
      title: "用户授权协议"
    }
  },
  {
    path: "/touch/authorizationProtocol", // 账号绑定授权登录pc页面
    name: "authorizationProtocol",
    component: resolve => {
      require(["../pages/touch/passport/authorizationProtocol.vue"], resolve);
    },
    meta: {
      title: "用户授权协议"
    }
  },
  {
    path: "/touch/accountSet",
    name: "touchAccountSet",
    redirect: "/touch/passwordSetFirst",
    component: resolve => {
      require(["../pages/touch/passport/accountSetIndex.vue"], resolve);
    },
    children: [
      {
        /**
         * type: 'forget' => 找回密码, 'change' => 修改密码,
         * phone：'' => 修改密码的原手机号和区号
         */
        path: "/touch/passwordSetFirst",
        name: "touchPasswordSetFirst",
        component: resolve => {
          require(["../pages/touch/passport/passwordSetFirst.vue"], resolve);
        },
        meta: {
          title: "修改密码-好未来帐号安全中心"
        }
      },
      {
        /*
         * type：'set' => 设置密码， 'forget' => 忘记密码  'change': 修改密码
         * phone: '' => 忘记密码的手机号和区号
         * tag: '' => 校验手机返回的标识
         */
        path: "/touch/passwordSetNext",
        name: "touchPasswordSetNext",
        component: resolve => {
          require(["../pages/touch/passport/passwordSetNext.vue"], resolve);
        },
        meta: {
          title: "修改密码-好未来帐号安全中心"
        }
      },
      {
        /**
         * type: 'bindPhone' =>'绑定手机号',
         *       'changePhone' => '修改手机号',
         *       'setPassword' => '设置密码',
         *       'changePassword' => '修改密码',
         *       'forgetPassword' => '忘记密码’
         * phone: '' => 新的登录手机号
         */
        path: "/touch/accountSetSuccess",
        name: "touchAccountSetSuccess",
        component: resolve => {
          require(["../pages/touch/passport/accountSetSuccess.vue"], resolve);
        },
        meta: {
          title: "操作成功-好未来帐号安全中心"
        }
      },
      {
        path: "/touch/helpCenterList",
        name: "helpCenterList",
        component: resolve => {
          require(["../pages/touch/passport/helpCenterList.vue"], resolve);
        },
        meta: {
          title: "帮助中心-好未来帐号安全中心"
        }
      },
      {
        path: "/touch/helpCenter",
        name: "touchHelpCenter",
        component: resolve => {
          require(["../pages/touch/passport/helpCenter.vue"], resolve);
        },
        meta: {
          title: "帮助中心-好未来帐号安全中心"
        }
      },
      {
        /**
         * type: 'change' => 修改手机号，'bind' => 绑定手机号
         * phone: '' => 修改手机号的原手机号
         */
        path: "/touch/phoneSet",
        name: "touchPhoneSet",
        component: resolve => {
          require(["../pages/touch/passport/phoneSet.vue"], resolve);
        },
        meta: {
          title: "换绑手机-好未来帐号安全中心"
        }
      },
      {
        /**
         * type: 'change' => 修改手机号，'bind' => 绑定手机号
         * tag: '' => 校验手机号返回的标识
         */
        path: "/touch/phoneSetNext",
        name: "touchPhoneSetNext",
        component: resolve => {
          require(["../pages/touch/passport/phoneSetNext.vue"], resolve);
        },
        meta: {
          title: "换绑手机-好未来帐号安全中心"
        }
      },
      {
        path: "/touch/404",
        name: "touch-404",
        component: resolve => {
          require(["../pages/touch/404.vue"], resolve);
        },
        meta: {
          title: "404-好未来帐号安全中心"
        }
      }
    ]
  },
  // 班级字典模块
  {
    path: "/userInfo/readingInfo",
    name: "readingInfo",
    component: resolve => {
      require(["../pages/touch/userInfo/readingInfo.vue"], resolve);
    },
    meta: {
      title: "在读信息"
    }
  },
  {
    path: "/touch/userInfo/readingInfo",
    name: "touchReadingInfo",
    component: resolve => {
      require(["../pages/touch/userInfo/readingInfo.vue"], resolve);
    },
    meta: {
      title: "在读信息"
    }
  },
  {
    path: "/userInfo/province",
    name: "province",
    component: resolve => {
      require(["../pages/touch/userInfo/province.vue"], resolve);
    },
    meta: {
      title: "所在省份"
    }
  },
  {
    path: "/touch/userInfo/province",
    name: "touchProvince",
    component: resolve => {
      require(["../pages/touch/userInfo/province.vue"], resolve);
    },
    meta: {
      title: "所在省份"
    }
  },
  {
    path: "/userInfo/city",
    name: "city",
    component: resolve => {
      require(["../pages/touch/userInfo/city.vue"], resolve);
    },
    meta: {
      title: "所在城市"
    }
  },
  {
    path: "/touch/userInfo/city",
    name: "touchCity",
    component: resolve => {
      require(["../pages/touch/userInfo/city.vue"], resolve);
    },
    meta: {
      title: "所在城市"
    }
  },
  {
    path: "/userInfo/county",
    name: "county",
    component: resolve => {
      require(["../pages/touch/userInfo/county.vue"], resolve);
    },
    meta: {
      title: "所在区县"
    }
  },
  {
    path: "/touch/userInfo/county",
    name: "touchCounty",
    component: resolve => {
      require(["../pages/touch/userInfo/county.vue"], resolve);
    },
    meta: {
      title: "所在区县"
    }
  },
  {
    path: "/userInfo/school",
    name: "school",
    component: resolve => {
      require(["../pages/touch/userInfo/school.vue"], resolve);
    },
    meta: {
      title: "在读学校"
    }
  },
  {
    path: "/touch/userInfo/school",
    name: "touchSchool",
    component: resolve => {
      require(["../pages/touch/userInfo/school.vue"], resolve);
    },
    meta: {
      title: "在读学校"
    }
  },
  {
    path: "/userInfo/addSchool",
    name: "addSchool",
    component: resolve => {
      require(["../pages/touch/userInfo/addSchool.vue"], resolve);
    },
    meta: {
      title: "申报学校信息"
    }
  },
  {
    path: "/touch/userInfo/addSchool",
    name: "touchAddSchool",
    component: resolve => {
      require(["../pages/touch/userInfo/addSchool.vue"], resolve);
    },
    meta: {
      title: "申报学校信息"
    }
  },
  {
    path: "/userInfo/404",
    name: "school-404",
    component: resolve => {
      require(["../pages/touch/userInfo/404.vue"], resolve);
    },
    meta: {
      title: "在读信息-404"
    }
  },
  {
    path: "/touch/userInfo/404",
    name: "touchSchool-404",
    component: resolve => {
      require(["../pages/touch/userInfo/404.vue"], resolve);
    },
    meta: {
      title: "在读信息-404"
    }
  },
  {
    path: "/unity/login",
    name: "unityLogin",
    component: resolve => {
      require(["../pages/touch/unity/login.vue"], resolve);
    },
    meta: {
      title: unityLoginTitle
    }
  },
  {
    path: "/touch/unity/login",
    name: "touchUnityLogin",
    component: resolve => {
      require(["../pages/touch/unity/login.vue"], resolve);
    },
    meta: {
      title: unityLoginTitle
    }
  },
  {
    path: "*",
    name: "404",
    redirect: "/404"
  }
];

PS_ROUTES.forEach(item => {
  if (item.path.indexOf("/touch/userInfo") > -1) {
    const beforeEnter = (to, from, next) => {
      if (window.xesApp && window.xesApp.setTitle) {
        window.xesApp && window.xesApp.setTitle(item.meta.title);
      }
      window.onload = () => {
        setTimeout(() => {
          window.xesApp && window.xesApp.setTitle(item.meta.title);
        }, 100);
      };
      next();
    };
    item.beforeEnter = beforeEnter;
  }
});

export { PS_ROUTES };



// WEBPACK FOOTER //
// ./common/commonModule/passport/router/routes.js